import { INSTALLMENT_FEES } from "./installmentsFee";

export function getInstallmentLabels({
  subtotal,
  shipping,
  maxInstallments = 6,
}) {
  const baseTotal = subtotal + shipping;

  return Array.from({ length: maxInstallments }, (_, i) => {
    const installment = i + 1;
    const feeRate = INSTALLMENT_FEES[installment] || 0;

    const total = baseTotal * (1 + feeRate);

    const installmentValue = total / installment;

    return {
      installment,
      total: Number(total.toFixed(2)),
      installmentValue: Number(installmentValue.toFixed(2)),
      hasFee: installment > 1 && feeRate > 0,
    };
  });
}
